import { QueryClient } from "@tanstack/react-query";

/**
 * Same defaults as maestro-ui's `app/providers.tsx` — the studio dashboard's real-time data
 * layer we're deliberately mirroring here. `staleTime: 0` because a punter-facing surface should
 * never show data it knows is behind; the per-hook overrides (e.g. `useVenueStateQuery`'s
 * `gcTime: Infinity`) are the exceptions, not the rule.
 *
 * Each app calls this once and passes the instance into its own `<QueryClientProvider>` — kiosk
 * and phone must not share a client.
 */
export function createTouchscreenQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,
        gcTime: 1000 * 60 * 5, // 5 minutes
      },
      mutations: {
        gcTime: 0,
      },
    },
  });
}
